import { AxiosError } from 'axios';

export default class ApiError extends Error {
  constructor(message: string, cause: AxiosError) {
    super(`${message}\nError: ${cause.message}\nResponse: ${JSON.stringify(cause.response?.data)}`);
  }
}
